import { createSlice } from "@reduxjs/toolkit";

const whiteListSlice = createSlice({
    name: "whiteList",
    initialState: {
        isLoading: false,
        whiteListData: [],
        requestLaonList: [],
        loanTransferStatus: [],
        dropdownProduct: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setWhiteListData(state, action) {
            state.whiteListData = action.payload;
        },
        setRequestLoanList(state, action) {
            state.requestLaonList = action.payload;
        },
        setLoanTransferStatus(state, action) {
            state.loanTransferStatus = action.payload;
        },
        setDropdownProduct(state, action) {
            state.dropdownProduct = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setWhiteListData,
    setRequestLoanList,
    setLoanTransferStatus,
    setDropdownProduct,
} = whiteListSlice.actions;
export default whiteListSlice.reducer;
